import React from "react";
import { FaBitcoin, FaBolt, FaWallet } from "react-icons/fa";

function Iterations() {
  return (
    <>
      <div
        className="process-style-three-area default-padding bg-dark text-light bg-cover"
        style={{
          backgroundImage:
            "url(https://validthemes.net/site-template/robok/assets/img/shape/banner-22.jpg)",
        }}
      >
        <div className="shape">
          <img
            src="https://validthemes.net/site-template/robok/assets/img/illustration/16.png"
            alt="Image Not Found"
          />
        </div>
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="site-heading">
                <h4 className="sub-title">How it works</h4>
                <h2 className="title split-text-right split-text-in-right">
                  Iterations of Bitcoin Wallets
                </h2>
                <p>
                  Bitcoin wallet falls under several categories with its
                  iterations depending on the network. Following are the
                  iterations offered by Xeer Technology.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-lg-10 offset-lg-2">
              <div className="process-style-three-items">
                <div className="process-style-three-item fade-up-anim">
                  <div className="icon">
                    <FaBitcoin size={40} />
                  </div>
                  <h4>SegWit Bitcoin Wallet</h4>
                  <p>
                    A SegWit wallet supports Bitcoin’s Segregated Witness
                    (SegWit) upgrade, enabling faster, lower-cost transactions
                    by separating signature data. It’s widely supported,
                    offering efficient network performance without changing
                    standard Bitcoin use.
                  </p>
                </div>

                <div className="process-style-three-item fade-up-anim">
                  <div className="icon">
                    <FaBolt size={40} />
                  </div>
                  <h4>Lightning Wallet</h4>
                  <p>
                    Lightning wallets utilize the Lightning Network for faster,
                    low-fee transactions. Ideal for frequent, small
                    transactions, they allow instant transfers through payment
                    channels, bypassing main blockchain confirmation times.
                  </p>
                </div>

                <div className="process-style-three-item fade-up-anim">
                  <div className="icon">
                    <FaWallet size={40} />
                  </div>
                  <h4>Bech32 Wallet</h4>
                  <p>
                    Bech32 wallets use Bitcoin’s Bech32 address format,
                    beginning with "bc1," for native SegWit addresses. This
                    format reduces transaction size, lowers fees, improves error
                    detection, and enhances user-friendliness.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Iterations;
